import { ADD_TO_BAG, ONE_TOUCH, PICKUP_STORE } from '@magalu/mixer-utils';
export var buildBeginCheckoutEvent = function buildBeginCheckoutEvent(cartId) {
  var _product$shipping, _product$shipping$, _product$shipping$$pa, _product$shipping$$pa2, _product$price;
  var product = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var location = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var context = arguments.length > 3 ? arguments[3] : undefined;
  return {
    cartId: cartId,
    cartTotalAmount: (product == null ? void 0 : product.price) && 1,
    cartTotalFreight: product == null ? void 0 : (_product$shipping = product.shipping) == null ? void 0 : (_product$shipping$ = _product$shipping[0]) == null ? void 0 : (_product$shipping$$pa = _product$shipping$.packages) == null ? void 0 : (_product$shipping$$pa2 = _product$shipping$$pa[0]) == null ? void 0 : _product$shipping$$pa2.price,
    cartTotalPrice: product == null ? void 0 : (_product$price = product.price) == null ? void 0 : _product$price.fullPrice,
    context: context,
    zipCode: location == null ? void 0 : location.zipCode
  };
};
export var buildProductEvent = function buildProductEvent() {
  var _product$price2, _product$price3, _product$seller;
  var product = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var context = arguments.length > 1 ? arguments[1] : undefined;
  return {
    context: context,
    price: product == null ? void 0 : (_product$price2 = product.price) == null ? void 0 : _product$price2.fullPrice,
    productCashPrice: product == null ? void 0 : (_product$price3 = product.price) == null ? void 0 : _product$price3.bestPrice,
    productId: product == null ? void 0 : product.variationId,
    sellerId: product == null ? void 0 : (_product$seller = product.seller) == null ? void 0 : _product$seller.id
  };
};
var productAddCart = function productAddCart() {
  var _window, _window$stewie;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    cartId = _ref.cartId,
    location = _ref.location,
    _ref$product = _ref.product,
    product = _ref$product === void 0 ? {} : _ref$product,
    _ref$channel = _ref.channel,
    channel = _ref$channel === void 0 ? '' : _ref$channel,
    _ref$typeButton = _ref.typeButton,
    typeButton = _ref$typeButton === void 0 ? ADD_TO_BAG : _ref$typeButton;
  if ((_window = window) == null ? void 0 : (_window$stewie = _window.stewie) == null ? void 0 : _window$stewie.api) {
    stewie.api.channel(channel);
    stewie.api.cart([buildProductEvent(product, typeButton)]);
    if ([ONE_TOUCH, PICKUP_STORE].includes(typeButton)) {
      stewie.api.beginCheckout(buildBeginCheckoutEvent(cartId, product, location, typeButton));
    }
    stewie.api.dispatch();
  }
};
export default productAddCart;